import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { Card, CardContent, Grid, Button } from "@material-ui/core/";
import { withStyles } from "@material-ui/core/styles";
import LoginStyles from "./LoginStyles";
import { createPasswordsSchema } from "./Password-schema";
import Classnames from 'classnames';
import Form from "./form";
import { resetPassword, resetLoginErrors } from "../Auth.ducks";
import Cookies from 'universal-cookie';
import queryString from 'querystring'
import srcIconLogo from "../../../styles/img/logo-kiuono-white.svg";
import { closeSnackBar } from "../../../reducers";
import { ErrorSnackbar, SuccessSnackbar } from "../../../components/IntegratedSnackbars";
import { API } from "../../../const";
import { useTranslation } from 'react-i18next';

import { useParams, Redirect } from "react-router-dom";
const LogoLogin = () => <object data={srcIconLogo} type="image/svg+xml" className="img-fluid logo-login" />

function ReinitPassword(props) {
  const { t } = useTranslation();

  const handleReset = (values) => {
    const parsed = queryString.parse(props.location.search);
    let data = {
      "confirmPassword": values.confirmPassword,
      "password": values.password,
      "code": parsed["?code"]
    }
    props.resetPassword(data);
  };
  function handleCloseError() {
    props.closeSnackBar("errorMsg")
  }
  function handleCloseSuccess() {
    props.closeSnackBar("successMsg")
    window.location.href = `${API}creche/login`;
  }


  const {
    resetLoginErrors,
    classes: { root, formBtn },
    auth: { error },
    match
  } = props;
  const parsed = queryString.parse(props.location.search);
  const displayHide = { display: "none" }
  const displayShow = { display: "block" }
  return (

    <div className="main-wrapper login-page">
      {props.successMsg.status ? <SuccessSnackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={props.successMsg.status}
        autoHideDuration={2000}
        onClose={handleCloseSuccess}
        variant="success"
        display={displayHide}
        message={props.successMsg.message}
      /> : ""}
      {props.errorMsg.status ? <ErrorSnackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={props.errorMsg.status}
        onClose={handleCloseError}
        autoHideDuration={5000}
        variant="error"
        display={displayShow}
        message={props.errorMsg.message}
      /> : ""}
      <div className="container-login">
        <div className="entete-login">
          <LogoLogin />
          <h1>{t('login.tagline')}</h1>
        </div>
        <Formik
          initialValues={{ password: "", confirmPassword: "" }}
          validationSchema={createPasswordsSchema(t)}
          onSubmit={(values, actions) => handleReset(values)}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            setFieldValue,
            errors,
            touched
          }) => {
            return (
              <form onSubmit={handleSubmit} className="box-login">
                <h2 className="mb-4">{t('reset_password.title')}</h2>
                <div className={Classnames("form-group", { "error-mess": errors.password && touched.password })}>
                  <input type="password" onChange={handleChange} name="password" className="form-control" id="ipt-password" placeholder={t('reset_password.password_placeholder')} />
                  {errors.password && touched.password ? (
                    <p >{errors.password}</p>
                  ) : null}
                </div>
                <div className={Classnames("form-group mb-2", { "error-mess": errors.confirmPassword && touched.confirmPassword })}>
                  <input type="password" onChange={handleChange} name="confirmPassword" className="form-control" id="ipt-password-confirm" placeholder={t('reset_password.confirm_placeholder')} />
                  {errors.confirmPassword && touched.confirmPassword ? (
                    <p >{errors.confirmPassword}</p>
                  ) : null}
                </div>
                <button type="submit"
                  onClick={handleSubmit} className="btn-gradient mt-4">{t('reset_password.submit')}</button>

              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

const mapStateToProps = ({ auth, successMsg, errorMsg }) => ({ auth, successMsg, errorMsg });

const mapDispatchToProps = { resetPassword, resetLoginErrors, closeSnackBar };

const withStore = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withStyles(LoginStyles)(withStore(ReinitPassword));
